export default "__VITE_ASSET__CbTSn_lg__"